export default [
    'ad',
    'ae',
    'af',
    'ag',
    'ai',
    'al',
    'am',
    'ao',
    'ar',
    'as',
    'at',
    'au',
    'aw',
    'ax',
    'az',
    'ba',
    'bb',
    'bd',
    'be',
    'bf',
    'bg',
    'bh',
    'bi',
    'bj',
    'bl',
    'bm',
    'bn',
    'bo',
    'bq-bo',
    'bq-sa',
    'bq-se',
    'br',
    'bs',
    'bt',
    'bw',
    'by',
    'bz',
    'ca',
    'ca-bc',
    'cc',
    'cd',
    'cf',
    'cg',
    'ch',
    'ci',
    'ck',
    'cl',
    'cm',
    'cn',
    'co',
    'cr',
    'cs',
    'cu',
    'cv',
    'cw',
    'cx',
    'cy',
    'cz',
    'de',
    'dj',
    'dk',
    'dm',
    'do',
    'dz',
    'easter_island',
    'ec',
    'ec-w',
    'ee',
    'eg',
    'eh',
    'el',
    'en',
    'er',
    'es',
    'es-ce',
    'es-cn',
    'es-ga',
    'es-ib',
    'es-ml',
    'es-pv',
    'esperanto',
    'et',
    'european_union',
    'fi',
    'fil',
    'fj',
    'fk',
    'fm',
    'fo',
    'fr',
    'fr-h',
    'ga',
    'gb',
    'gb-eng',
    'gb-ork',
    'gb-sct',
    'gb-wls',
    'gd',
    'ge',
    'ge-ab',
    'gg',
    'gh',
    'gi',
    'gl',
    'gm',
    'gn',
    'gq',
    'gr',
    'gt',
    'gu',
    'gw',
    'gy',
    'hausa',
    'hk',
    'hmong',
    'hn',
    'hr',
    'ht',
    'hu',
    'id',
    'ie',
    'il',
    'im',
    'in',
    'io',
    'iq',
    'ir',
    'is',
    'it',
    'it-82',
    'it-88',
    'ja',
    'je',
    'jm',
    'jo',
    'jp',
    'kannada',
    'ke',
    'kg',
    'kh',
    'ki',
    'km',
    'kn',
    'ko',
    'kp',
    'kr',
    'kurdistan',
    'kw',
    'ky',
    'kz',
    'la',
    'lb',
    'lc',
    'li',
    'lk',
    'lr',
    'ls',
    'lt',
    'lu',
    'lv',
    'ly',
    'ma',
    'malayali',
    'maori',
    'mc',
    'md',
    'me',
    'mg',
    'mh',
    'mk',
    'ml',
    'mm',
    'mn',
    'mo',
    'mp',
    'mq',
    'mr',
    'ms',
    'mt',
    'mu',
    'mv',
    'mw',
    'mx',
    'my',
    'mz',
    'na',
    'nato',
    'ne',
    'nf',
    'ng',
    'ni',
    'nl',
    'no',
    'northern_cyprus',
    'np',
    'nr',
    'nu',
    'nz',
    'om',
    'pa',
    'pe',
    'pf',
    'pg',
    'ph',
    'pk',
    'pl',
    'pn',
    'pr',
    'ps',
    'pt',
    'pt-20',
    'pt-30',
    'pw',
    'py',
    'qa',
    'ro',
    'rs',
    'ru',
    'rw',
    'sa',
    'sb',
    'sc',
    'sd',
    'se',
    'sg',
    'si',
    'sindh',
    'sk',
    'sl',
    'sm',
    'sn',
    'so',
    'somaliland',
    'south_ossetia',
    'sr',
    'ss',
    'st',
    'sv',
    'sx',
    'sy',
    'sz',
    'ta',
    'tc',
    'td',
    'tg',
    'th',
    'tibet',
    'tj',
    'tk',
    'tl',
    'tm',
    'tn',
    'to',
    'tr',
    'transnistria',
    'tt',
    'tv',
    'tw',
    'tz',
    'ua',
    'ug',
    'united_nations',
    'us',
    'us-hi',
    'uy',
    'uz',
    'va',
    'vc',
    've',
    'vg',
    'vi',
    'vn',
    'vu',
    'ws',
    'xk',
    'xx',
    'ye',
    'yiddish',
    'za',
    'zh-hans',
    'zm',
    'zw',
]
